var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "left" }, [
      _vm.$route.query.again == 1
        ? _c("div", { staticClass: "title" }, [_vm._v("重开采购入库退货单")])
        : _c("div", { staticClass: "title" }, [_vm._v("新增采购入库退货单")]),
      _vm.leftContent.orderPurchaseInOrderBase
        ? _c("div", { staticClass: "codeInfo" }, [
            _c("div", [
              _vm._v(" 采购退货编号："),
              _c("span", { staticStyle: { color: "#436ae8" } }, [
                _vm._v(_vm._s(_vm.leftContent.purchaseReturnOrderNo)),
              ]),
            ]),
            _c("div", [
              _vm._v(
                " 制单人：" +
                  _vm._s(_vm.leftContent.orderPurchaseInOrderBase.createdName) +
                  " "
              ),
            ]),
            _c("div", [
              _vm._v(
                " 制单时间：" +
                  _vm._s(
                    _vm.$moment(
                      _vm.leftContent.orderPurchaseInOrderBase.createdTime
                    )
                  ) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "leftContext" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.leftContent.orderPurchaseInOrderItemList } },
            [
              _vm.$route.query.type
                ? _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delBut(scope.$index)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3075173066
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "供应商" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.supplierName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库部门" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.inDepotOrgName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库仓库" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          _vm._l(
                            scope.row.orderPurchaseInOrderProdDepotList,
                            function (iten) {
                              return _c(
                                "p",
                                {
                                  key: iten.id,
                                  staticStyle: { display: "inline-block" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(iten.inDepotName)),
                                  ]),
                                  scope.row.orderPurchaseInOrderProdDepotList
                                    .length > 1
                                    ? _c("span", [_vm._v(",")])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "入库商品",
                  width: "150px",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.inDepotProdName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.inDepotProdImage
                          ? _c("img", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: {
                                src: _vm.ImgHttps + scope.row.inDepotProdImage,
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDetails(scope.row)
                                },
                              },
                            })
                          : _c("span", [_vm._v("/")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.inDepotProdType == 1
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("商品")]
                            )
                          : _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("赠品")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.inDepotProdBrandName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.inDepotProdQuantity))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseProdPrice))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库金额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseProdAmount))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "未入库数量", width: "100px;" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.notInDepotProdQuantity))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "可退数量", width: "80px;" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.canOperateQuantity))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "title" }, [_vm._v("操作")]),
      _c(
        "div",
        { staticClass: "rightContext", staticStyle: { border: "0" } },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "90px" } },
            [
              _c("el-form-item", { attrs: { label: "退货部门" } }, [
                _c(
                  "div",
                  { staticClass: "selectTree" },
                  [
                    _c("treeselect", {
                      attrs: {
                        disabled: "",
                        options: _vm.options,
                        "search-nested": "",
                        normalizer: _vm.normalizer,
                        noResultsText: "未找到",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.inDepotOrgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "inDepotOrgCode", $$v)
                        },
                        expression: "form.inDepotOrgCode",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "退货供应商" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "供应商名称",
                      value: _vm.form.supplierName,
                      supplierName: "",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货类型" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "退货类型",
                      value: _vm.form.inDepotProdType == 1 ? "商品" : "赠品",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货商品" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "退货商品",
                      value: _vm.form.inDepotProdName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货规格" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "退货规格",
                      value: _vm.form.inDepotProdSpecificationName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货品牌" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "退货品牌",
                      value: _vm.form.inDepotProdBrandName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货数量" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: "",
                      size: "small",
                      placeholder: "退货数量",
                      value: _vm.form.backNumber,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货金额" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "退货金额",
                      value: _vm.form.backMOney,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货仓库" } },
                _vm._l(_vm.form.backDepotList, function (ite, index) {
                  return ite.type == 0 || ite.type == undefined
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "min-width": "450px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                value: ite.returnDepotName,
                                size: "mini",
                                "value-key": "id",
                                placeholder: "请选择",
                                disabled: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.myWareListChange($event, ite)
                                },
                              },
                            },
                            _vm._l(_vm.wareList.list, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item },
                              })
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _vm._v(
                                " 可操作数:" +
                                  _vm._s(
                                    ite.canOperateQuantity - ite.backNumber
                                  ) +
                                  " "
                              ),
                              _c("el-input-number", {
                                staticStyle: { "margin-right": "10px" },
                                attrs: {
                                  size: "mini",
                                  min: 0,
                                  max: ite.canOperateQuantity,
                                  placeholder: "请输入库存数量",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.inputChange(ite)
                                  },
                                },
                                model: {
                                  value: ite.backNumber,
                                  callback: function ($$v) {
                                    _vm.$set(ite, "backNumber", $$v)
                                  },
                                  expression: "ite.backNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "请输入备注",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.textarea,
                      callback: function ($$v) {
                        _vm.textarea = $$v
                      },
                      expression: "textarea",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "text-align": "right", "margin-top": "50px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }